(() => {
  const overlay = document.querySelector('[data-sj-route-transition]');
  if (!overlay) return;
  const status = overlay.querySelector('[data-sj-route-status]');
  const progress = overlay.querySelector('[data-sj-route-progress]');
  const percent = overlay.querySelector('[data-sj-route-percent]');
  const pageKey = document.body.classList.contains('sj-jamverse-page')
    ? 'jamverse'
    : document.querySelector('[data-sjh-kind="helmet"]')
      ? 'helmet'
      : document.querySelector('[data-sjh-kind="scooter"]') ? 'scooter' : 'ordinary';
  const statusCopy = {
    jamverse: 'OPENING THE JAMVERSE',
    helmet: 'FITTING YOUR HELMET',
    scooter: 'GETTING YOUR RIDE READY',
    ordinary: 'GETTING STREETJAM READY'
  };
  if (status) status.textContent = statusCopy[pageKey];

  let shown = false;
  let complete = false;
  let showTimer = 0;
  let failOpenTimer = 0;
  let progressValue = 0;
  const setProgress = (value) => {
    progressValue = Math.max(progressValue, Math.min(100, Math.round(value)));
    overlay.style.setProperty('--sj-route-progress', `${progressValue}%`);
    if (progress) progress.style.width = `${progressValue}%`;
    if (percent) percent.textContent = `${progressValue}%`;
  };
  const reveal = () => {
    window.clearTimeout(showTimer);
    window.clearTimeout(failOpenTimer);
    complete = true;
    setProgress(100);
    const hide = () => {
      overlay.removeAttribute('data-active');
      overlay.removeAttribute('data-thin');
      overlay.setAttribute('aria-hidden', 'true');
    };
    if (!shown || matchMedia('(prefers-reduced-motion: reduce)').matches) hide();
    else window.setTimeout(hide, 140);
  };
  const show = () => {
    if (complete || shown) return;
    shown = true;
    overlay.dataset.active = 'true';
    overlay.setAttribute('aria-hidden', 'false');
  };

  const criticalCandidates = Array.from(document.querySelectorAll(
    '[fetchpriority="high"], .sj-hybrid__stage img[loading="eager"], .sj-cinematic img[loading="eager"]'
  )).filter((image, index, list) => list.indexOf(image) === index);
  const isVisibleCriticalImage = (image) => {
    try {
      if (typeof image.checkVisibility === 'function' && !image.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    } catch (_error) {}
    const rect = image.getBoundingClientRect();
    return rect.width > 0
      && rect.height > 0
      && rect.bottom > 0
      && rect.right > 0
      && rect.top < window.innerHeight
      && rect.left < window.innerWidth;
  };
  const visibleCriticalImages = criticalCandidates.filter(isVisibleCriticalImage);
  const criticalPool = visibleCriticalImages.length ? visibleCriticalImages : criticalCandidates;
  const criticalSources = new Set();
  const criticalImages = criticalPool.filter((image) => {
    const source = image.currentSrc || image.src || '';
    if (!source || criticalSources.has(source)) return false;
    criticalSources.add(source);
    return true;
  }).slice(0, 10);
  const sessionKey = `sj-critical-ready:${pageKey}`;
  const siteEntryKey = 'sj-site-entry-ready';
  let alreadyReady = false;
  let siteEntryReady = false;
  try {
    alreadyReady = sessionStorage.getItem(sessionKey) === '1';
    siteEntryReady = sessionStorage.getItem(siteEntryKey) === '1';
  } catch (_) {}
  if (!siteEntryReady || (!alreadyReady && pageKey !== 'ordinary')) {
    showTimer = window.setTimeout(show, 180);
  }
  failOpenTimer = window.setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'route_transition', status: 'timeout', destination_path: location.pathname });
    reveal();
  }, 4000);

  let decodedCount = 0;
  const decodeTasks = criticalImages.map((image) => {
    const done = () => {
      decodedCount += 1;
      setProgress(20 + (decodedCount / Math.max(1, criticalImages.length)) * 75);
    };
    if (image.complete && image.naturalWidth > 0) { done(); return Promise.resolve(); }
    if (typeof image.decode === 'function') return image.decode().catch(() => undefined).then(done);
    return new Promise((resolve) => {
      image.addEventListener('load', () => { done(); resolve(); }, { once: true });
      image.addEventListener('error', () => { done(); resolve(); }, { once: true });
    });
  });
  setProgress(document.readyState === 'loading' ? 5 : 20);
  const domReady = document.readyState === 'loading'
    ? new Promise((resolve) => document.addEventListener('DOMContentLoaded', () => { setProgress(20); resolve(); }, { once: true }))
    : Promise.resolve();
  Promise.all([domReady, ...decodeTasks]).then(() => {
    try {
      sessionStorage.setItem(sessionKey, '1');
      sessionStorage.setItem(siteEntryKey, '1');
    } catch (_) {}
    reveal();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) reveal(); });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.href === location.href) return;
    window.setTimeout(() => {
      if (document.visibilityState === 'visible') {
        overlay.dataset.thin = 'true';
        overlay.dataset.active = 'true';
        overlay.setAttribute('aria-hidden', 'false');
        setProgress(35);
      }
    }, 250);
  }, true);
})();
